var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollerShutter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.28 26.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#fff;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{fill:#fff;}.cls-3{stroke:#2d2d2d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "roller_shutter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.38,
    y: 13.28,
    width: 25.53,
    height: 12.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "0.38 13.76 0.38 0.38 25.91 0.38 25.91 13.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.32,
    y1: 6.83,
    x2: 0.96,
    y2: 6.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.32,
    y1: 3.33,
    x2: 0.96,
    y2: 3.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.32,
    y1: 10.39,
    x2: 0.96,
    y2: 10.39
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollerShutter);
export default __webpack_public_path__ + "static/media/roller_shutter.4b51021ce2321f4e04f92cca4a6e5e51.svg";
export { ForwardRef as ReactComponent };